import { FC } from 'react';

import EditIncentivesMarketTermsAndConditionsTemplateModalBody from './components/EditIncentivesMarketTermsAndConditionsTemplateModalBody';
import EditIncentivesMarketTermsAndConditionsTemplateModalFooter from './components/EditIncentivesMarketTermsAndConditionsTemplateModalFooter';
import EditIncentivesMarketTermsAndConditionsTemplateModalHeader from './components/EditIncentivesMarketTermsAndConditionsTemplateModalHeader';

const EditIncentivesMarketTermsAndConditionsTemplateModal: FC = () => (
  <>
    <EditIncentivesMarketTermsAndConditionsTemplateModalHeader />
    <EditIncentivesMarketTermsAndConditionsTemplateModalBody />
    <EditIncentivesMarketTermsAndConditionsTemplateModalFooter />
  </>
);

export default EditIncentivesMarketTermsAndConditionsTemplateModal;
